"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.draw45DegreeLine = exports.drawPoints = exports.drawAxisLabel = exports.drawAxisGridLines = exports.drawAxis = exports.formatAxis = exports.getLinearAxis = exports.AxisPosition = exports.TickFormat = exports.kFormat = exports.roundTwoDecimals = void 0;
var d3 = require("d3");
var styles = require("../styles/PredictionModelResultsViz");
var colors = require("../util/colors");
var roundTwoDecimals = function (n) {
    return Math.round(n * 100) / 100;
};
exports.roundTwoDecimals = roundTwoDecimals;
var kFormat = function (num) {
    if (Math.abs(num) > 999) {
        return (Math.sign(num) * (Math.round(Math.abs(num) / 100) / 10)).toString() + 'K';
    }
    return Math.sign(num) * Math.abs(num);
};
exports.kFormat = kFormat;
exports.TickFormat = {
    hideNumbers: function () { return ''; },
    hideEnds: function (x) { return (x === 0 || x === 1 ? '' : "" + exports.kFormat(x.valueOf())); },
    formatK: function (x) { return "" + exports.kFormat(x.valueOf()); },
    progressBar: function (x) { return (x === 0 ? '00|0.0' : x === 1 ? '1.0|00' : x.toString()); },
};
var AxisPosition;
(function (AxisPosition) {
    AxisPosition[AxisPosition["Top"] = 0] = "Top";
    AxisPosition[AxisPosition["Bottom"] = 1] = "Bottom";
    AxisPosition[AxisPosition["Left"] = 2] = "Left";
    AxisPosition[AxisPosition["Right"] = 3] = "Right";
})(AxisPosition = exports.AxisPosition || (exports.AxisPosition = {}));
var getLinearAxis = function (scale, position) {
    // create axis
    switch (position) {
        case AxisPosition.Top:
            return d3.axisTop(scale);
        case AxisPosition.Bottom:
            return d3.axisBottom(scale);
        case AxisPosition.Left:
            return d3.axisLeft(scale);
        case AxisPosition.Right:
            return d3.axisRight(scale);
    }
};
exports.getLinearAxis = getLinearAxis;
var formatAxis = function (axis, numTicks, tickSize, tickPadding, tickFormat) {
    if (tickSize === void 0) { tickSize = 0; }
    if (tickPadding === void 0) { tickPadding = 7; }
    axis.ticks(numTicks).tickSize(tickSize).tickPadding(tickPadding);
    if (tickFormat) {
        axis.tickFormat(tickFormat);
    }
};
exports.formatAxis = formatAxis;
var drawAxis = function (svg, axis, xTranslate, yTranslate) {
    svg // draw y-axis
        .append('g')
        .attr('class', styles.axis)
        .attr('transform', "translate( " + xTranslate + ", " + yTranslate + ")")
        .call(axis);
};
exports.drawAxis = drawAxis;
// background lines util
var drawAxisGridLines = function (svg, axis, xTranslate, yTranslate) {
    svg // draw background lines
        .append('g')
        .attr('transform', "translate( " + xTranslate + ", " + yTranslate + ")")
        .call(axis)
        .select('.domain')
        .remove();
    svg.selectAll('.tick line').attr('stroke', colors.veryLightGray);
};
exports.drawAxisGridLines = drawAxisGridLines;
// axis labels
var drawAxisLabel = function (svg, label, x, y, isRotated) {
    if (isRotated === void 0) { isRotated = false; }
    if (isRotated) {
        svg // draw label for y axis
            .append('g')
            .attr('class', styles.axisLabel)
            .attr('transform', "translate(" + x + ", " + y + ")")
            .append('text')
            .attr('transform', 'rotate(-90)')
            .text(label || '');
    }
    else {
        svg // draw label for x axis
            .append('text')
            .attr('class', styles.axisLabel)
            .attr('x', x)
            .attr('y', y)
            .text(label);
    }
};
exports.drawAxisLabel = drawAxisLabel;
var drawPoints = function (svg, coordinates, xScale, yScale, color, radius, opacity) {
    if (color === void 0) { color = colors.defaultBlue; }
    if (radius === void 0) { radius = 5; }
    if (opacity === void 0) { opacity = 1; }
    svg
        .append('g')
        .selectAll('dot')
        .data(coordinates)
        .enter()
        .append('circle')
        .attr('cx', function (d) {
        return xScale(d[0] || 0) || 0;
    })
        .attr('cy', function (d) {
        return yScale(d[1] || 0) || 0;
    })
        .attr('r', radius)
        .style('fill', color)
        .style('opacity', opacity);
};
exports.drawPoints = drawPoints;
var draw45DegreeLine = function (svg, xScale, yScale, coordinates, // If you want to show points along 45 degree line
opacity) {
    var start = Math.max(yScale.domain()[0], xScale.domain()[0]);
    var end = Math.min(yScale.domain()[1], xScale.domain()[1]);
    svg
        .append('line')
        .attr('x1', xScale(start) || 0)
        .attr('y1', yScale(start) || 0)
        .attr('x2', xScale(end) || 0)
        .attr('y2', yScale(end) || 0)
        .attr('stroke-width', 3)
        .attr('stroke', opacity ? colors.black : colors.gray)
        .style('opacity', opacity || 1);
    // Plot points along 45 degree line
    if (coordinates) {
        var points = coordinates.map(function (coord) {
            return [coord[0], coord[0]];
        });
        exports.drawPoints(svg, points, xScale, yScale, colors.black, 3, 0.29);
    }
};
exports.draw45DegreeLine = draw45DegreeLine;
//# sourceMappingURL=utils.js.map